export const name = 'globalCss' as const
export { VSM_EDITOR_CONFIGS_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'
export const GlobalCssAPISymbol = Symbol('GlobalCssAPISymbol')
export const GlobalCssDsAPISymbol = Symbol('GlobalCssDsAPISymbol')
